import { Badge } from '@/components/ui/badge';
import type { Severity } from '@/types/forensics';

const SEVERITY_LABELS: Record<Severity, string> = {
  high: 'High',
  medium: 'Medium',
  low: 'Low',
  info: 'Info',
};

interface SeverityBadgeProps {
  severity: Severity;
  className?: string;
}

export default function SeverityBadge({ severity, className }: SeverityBadgeProps) {
  return (
    <Badge variant={severity} className={className}>
      {SEVERITY_LABELS[severity]}
    </Badge>
  );
}
